/** Hardcoded support-chat client settings (edit here, not .env). */
export const SUPPORT_CHAT_CONFIG = {
  ragEnabled: true,
  apiPath: '/ai/support-chat',
  requestTimeoutMs: 60_000,
  /** Public site URL for Siri / Google Assistant web deep links (no trailing slash). */
  publicSiteUrl: 'https://serviceonclick.com',
  siriDefaultPath: '/home',
  /** Native app URL scheme (Expo `scheme` in ots/app.config.js). */
  nativeAppScheme: 'ots',
  /** Hosted .shortcut files for one-tap Siri install (paths on publicSiteUrl). */
  siriShortcutFiles: {
    bookWeb: '/siri/soc-book-service.shortcut',
    trackWeb: '/siri/soc-track-orders.shortcut',
    bookApp: '/siri/soc-book-service-app.shortcut',
  },
} as const;
